import { FormEvent, useState } from "react"
import UseForm from "../../hooks/useForm"
import { HomeI, HomeMediasI } from "../../models/home"
import { updateHome, updateHomeCategorias } from "../../services/home"
import { handleChangeFile } from "../../utils/files"

const useHome = (home:HomeI) => {

    const {formData, onChange, setFormData} = UseForm(home)
    const [medias, setMedias] = useState<HomeMediasI>({})
    const [isLoading, setIsLoading] = useState(false)
    const [categoriasEliminadas, setCategoriasEliminadas] = useState<string[]>([])
    const [isSubmitting, setIsSubmitting] = useState(false)

    const onChangeVideoPrincipal = (e:React.ChangeEvent<HTMLInputElement>) => {
        setMedias(prev => ({
            ...prev,
            videoPrincipal:handleChangeFile(e)
        }))
    }

    const onSubmitForm = async (e:FormEvent) => {

        e.preventDefault()

        try {
            setIsLoading(true)
            const home:HomeI = {
                ...formData,
            }
            if(home.categorias && home.categorias.length > 0){
                delete (home as any).categorias
            }
            setIsSubmitting(true)

            await updateHome({
                data:home,
                medias,
            })

            const data = new FormData();
            const categoriasData = formData.categorias;

            categoriasData.forEach((categoria, index) => {
                data.append(`categorias[${index}][nombre]`, categoria.nombre || '');
                data.append(`categorias[${index}][categoria]`, categoria.categoria || '');
                data.append(`categorias[${index}][orden]`, String(categoria.orden || index));
                
                if (categoria.id) {
                    data.append(`categorias[${index}][id]`, categoria.id);
                }
                
                console.log(categoria.media);
                if (categoria.media) {
                    if (categoria.media instanceof File) {
                        // Los archivos NO pueden ir dentro de arrays, deben ir al nivel superior
                        data.append(`categorias_media_${index}`, categoria.media);
                    } else {
                        // Si es string (ruta), sí puede ir en el array
                        data.append(`categorias[${index}][media]`, categoria.media);
                    }
                }
            });
            
            data.append('categoriasEliminadas', JSON.stringify(categoriasEliminadas));
            // FormData no se muestra con console.log normal, usa entries()
            console.log('FormData contenido:', Object.fromEntries(data.entries()));

            
            await updateHomeCategorias({
                data:data,
            })

            alert("Datos actualiados")
            setIsLoading(false)
        } catch(e){
            alert("Ocurrió un error")
            console.error("Error ", e)
        } finally {
            setIsSubmitting(false)
        } 

    }

    const handleCategoriaFieldChange = (
        index: number, 
        field: 'nombre' | 'imagen' | 'categoria' | 'orden', 
        value: string | File, 
        name: 'categorias'
    ) => {
        setFormData(prev => ({
            ...prev,
            [name]: prev[name].map((item, i) => 
                i === index ? { ...item, [field]: value } : item
            )
        }))
    }

    const removeCategoria = (index: number) => {
        console.log(index)
        const categoriaEliminada = formData.categorias[index];
        if (categoriaEliminada?.id) {
            setCategoriasEliminadas(prev => [...prev, categoriaEliminada.id!]);
        }
        
        setFormData(prev => {
          
            const updatedCategorias = [...prev.categorias];
            updatedCategorias.splice(index, 1);

          return {
            ...prev,
            categorias: updatedCategorias
          }  
        });
    }
    


    return {
        onChangeVideoPrincipal,
        formData,
        onChange,
        onSubmitForm,
        setFormData,
        handleCategoriaFieldChange,
        removeCategoria,
        isLoading,
        isSubmitting,
    }

}

export default useHome